/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DocumentSasUrlDto } from '../../models/document-sas-url-dto';

export interface GetBillableServicesDocumentProof$Params {
  customerId: number;

/**
 * filter date by range from/to
 */
  date?: string;

/**
 * filter time in decimal by number range from/to
 */
  time?: string;

/**
 * filter for property billableServiceCategory by ids
 */
  billableServiceCategoryIds?: Array<number>;

/**
 * filter for property billableServiceTypeIds by ids
 */
  billableServiceTypeIds?: Array<number>;

/**
 * filter for property securityExpertId by ids
 */
  securityExpertIds?: Array<number>;
  asdApprovalNumber?: string;
  asdFactor?: string;
  asdNote?: string;
  billedDataName?: string;
  contactPersonName?: string;
  id?: string;
  quarter?: string;
  svgNote?: string;
  limit?: number;
  offset?: number;
  sortBy?: string;
  sortOrder?: 'ASC' | 'DESC';
}

export function getBillableServicesDocumentProof(http: HttpClient, rootUrl: string, params: GetBillableServicesDocumentProof$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentSasUrlDto>> {
  const rb = new RequestBuilder(rootUrl, getBillableServicesDocumentProof.PATH, 'get');
  if (params) {
    rb.path('customerId', params.customerId, {});
    rb.query('date', params.date, {});
    rb.query('time', params.time, {});
    rb.query('billableServiceCategoryIds', params.billableServiceCategoryIds, {});
    rb.query('billableServiceTypeIds', params.billableServiceTypeIds, {});
    rb.query('securityExpertIds', params.securityExpertIds, {});
    rb.query('asdApprovalNumber', params.asdApprovalNumber, {});
    rb.query('asdFactor', params.asdFactor, {});
    rb.query('asdNote', params.asdNote, {});
    rb.query('billedDataName', params.billedDataName, {});
    rb.query('contactPersonName', params.contactPersonName, {});
    rb.query('id', params.id, {});
    rb.query('quarter', params.quarter, {});
    rb.query('svgNote', params.svgNote, {});
    rb.query('limit', params.limit, {});
    rb.query('offset', params.offset, {});
    rb.query('sortBy', params.sortBy, {});
    rb.query('sortOrder', params.sortOrder, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DocumentSasUrlDto>;
    })
  );
}

getBillableServicesDocumentProof.PATH = '/customers/{customerId}/billable-services/document/proof';
